import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', (event) => {
    const servicesNav = document.querySelector('.services-navigation');
    
    if( servicesNav ) {
        const sections = document.querySelectorAll('.service-section');
        const lastSection = document.getElementById(sections[sections.length - 1].getAttribute('id'));
        const navItems = servicesNav.querySelectorAll('li')
        
        if( lastSection ) {        
            // pin the nav
            ScrollTrigger.create({
                trigger: servicesNav,
                start: 'top 110px',
                end: 'bottom' - lastSection.offsetHeight,
                endTrigger: lastSection.lastElementChild,
                // markers: true,
                pin: true, 
                pinSpacing: false 
            });
            
            gsap.utils.toArray(navItems).forEach(function(navItem) {

                // adds active class to each section
                gsap.to( navItem, {
                    scrollTrigger: {
                        start: '-40px 166px',
                        end: 'bottom 166px',
                        trigger: document.getElementById(navItem.className), // service section
                        onEnter: () => {
                            navItem.classList.add('active')
                        },
                        onLeave: () => {
                            navItem.classList.remove('active')
                        },
                        onEnterBack: () => {
                            navItems.forEach(item => {
                               item.classList.remove('active');
                            });
                            navItem.classList.add('active')
                        },
                        // markers: true,
                        // once: true
                    }
                });
            });
        }
    }
});